export const artworkImage = (artwork) => (
  artwork?.image_url
  || artwork?.images?.find((image) => image.is_primary)?.image_url
  || artwork?.images?.[0]?.image_url
  || ''
);

export const coverPhoto = (photos = []) => photos.find((photo) => photo.is_cover) || photos[0] || null;

// Thumbnail, card, or hero image for an exhibition: the cover photo first,
// then the saved image_url (which mirrors the cover), then the first artwork.
export const exhibitionCoverImage = (exhibition) => (
  coverPhoto(exhibition?.photos)?.image_url
  || exhibition?.cover_image_url
  || exhibition?.image_url
  || artworkImage(exhibition?.artworks?.[0])
  || ''
);
